import {
    DOMAIN_EXTRA_CHARS,
    DOMAIN_HYPHEN_OPENING_TRAILING,
    DOMAIN_INVALID_CHARS,
    DOMAIN_STRUCTURE, SUBDOMAIN_EXTRA_CHARS,
    SUBDOMAIN_STRUCTURE
} from "./domain";

export function validateDomain(domain, isPackage) {

    let isValid = true;
    let message = null;

    let contains = regexp => new RegExp(regexp, 'g').test(domain);

    switch (true) {
        case contains(DOMAIN_INVALID_CHARS):
            isValid = false;
            message = 'Invalid characters. Only english lowercase characters and hyphen are allowed (a-z, 0-9, "-")';
            break;
        case contains(DOMAIN_HYPHEN_OPENING_TRAILING):
            isValid = false;
            message = 'Domain cannot have an opening or trailing hyphen (-). Please, make sure the hyphen is closed by letters or numbers';
            break;
        case !contains(SUBDOMAIN_STRUCTURE) && !!domain && !!isPackage:
            isValid = false;
            message = 'App subdomain should contain at least one subdomain (up to three), one base domain and one top-level domain (ex. "com", "org")';
            break;
        case !contains(DOMAIN_STRUCTURE) && !!domain && !isPackage:
            isValid = false;
            message = 'Domain name should contain up to two subdomains, one top-level domain (ex. "com", "org") and one base domain';
            break;
        case !contains(SUBDOMAIN_EXTRA_CHARS) && !!domain && !!isPackage:
            isValid = false;
            message = "App subdomain name must be lowercase and must not contain special characters but a hyphen (-)";
            break;
        case !contains(DOMAIN_EXTRA_CHARS) && !!domain && !isPackage:
            isValid = false;
            message = "Base domain name must be lowercase and must not contain special characters but a hyphen (-)";
            break;
        default:
            break;
    }

    return {
        isValid: isValid,
        message: message,
    }
}